<template>
    <div class="hxstepsDetail23">
        <div id="amapContainer" style="width:100vw;height:100vh;"></div>
        <!-- <div class="notice">
          <van-notice-bar
              color="#ffffff" background="rgba(0,0,0,.3)"
              left-icon="volume-o"
              text="地图非真实比例地图，详细地址见点位信息。"
          />
        </div> -->

        <div class="header">
            <van-image :src="userInfo.userInfo.avatarurl"></van-image>
            <span>
                <ICountUp :endVal="userTaskInfo.totalSteps*1"/>
            </span>
            
            <span>
                <div class="fff">
                    <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20230828/1693216490/580559.png" alt="">
                    <span>{{userTaskInfo.percent}} %</span>
                </div>
                自  {{userTaskInfo.join_start_time}}起累计
            </span>
         
        </div>
        <div class="header2" @click="gogroup">
            <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20230904/1693806910/9640.png" alt="">
            <div class="" v-if="userTaskInfo.groupid == ''">
                <div>邀请好友组队</div>
                <div>获得加速</div>
            </div>
            <span v-else>{{userTaskInfo.count}} </span>
        </div>
        <div class="rules" @click="getcard" v-if="userTaskInfo.currentFinished>=12">
            <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20230918/1695028763/107863.png" alt/>
        </div>
        <div class="rank" @click="gorank">
            <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20221209/1670567106/509808.png" alt/>
        </div>
        <div class="rel" @click="getpic" v-if="list.length >0">
            <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20230918/1695028763/330769.png" alt/>
        </div>
        <div class="footer">
            <div>
                <span>{{userTaskInfo.currentFinished}}</span>
                已点亮点位
            </div>
            <div @click="handleSteps" v-if="userTaskInfo.currentFinished<12">
                <a>GO</a>
            </div>
            <div @click="subshow = true" v-if="userTaskInfo.currentFinished==12 && (slist.length == 0 && wlist.length == 0||list.length == 0)">
                <a style="font-size:.4rem;">上传<br/>照片</a>
            </div>
            <div @click="getpic" v-if="userTaskInfo.currentFinished>=12 && slist.length == 0 && wlist.length > 0">
              <a style="font-size:.4rem;">
                等待
                <br/>审核
              </a>
            </div>
            <div @click="gofinsh" v-if="userTaskInfo.currentFinished==15">
              <a style="font-size:.4rem;">
                完赛
              </a>
            </div>

            <div>
                <template v-if="acid">
                    <div>
                        <span>{{freenum}}</span>
                        抽奖机会
                    </div>
                    <img src="@/assets/img/steps/draw.png"  alt @click="goluckdraw"/>
                </template>
                
            </div>
        </div>
        <van-dialog
                v-model="rulesShow"
                title="活动规则"
                :style="{width:'80vw' }"
                round
                close-on-click-overlay
        >
            <div style="padding:0rem;overflow: scroll;height:40vh;" v-html="detail.intro"></div>
        </van-dialog>
        <Popup
            v-model="pointShow"
            get-container="#app"
            :style="{ width: '80%',overflowY:'inherit' }"
            round
            close-on-click-overlay
            @closed="closepointShow"
        >
            <div :class="['xhpointDesc',activityPoints.playerInfo == null||activityPoints.playerInfo == ''?'isfalse':'']">
                <!-- <div id="fireworks" v-if="activityPoints.playerInfo!=null && activityPoints.id==137">
                    <img src="@/assets/img/steps/fire/1.png" alt="">
                    <img src="@/assets/img/steps/fire/2.png" alt="">
                    <img src="@/assets/img/steps/fire/3.png" alt="">
                    <img src="@/assets/img/steps/fire/4.png" alt="">
                    <img src="@/assets/img/steps/fire/5.png" alt="">
                </div> -->
                <div>
                    <header>
                        <div class="headertitle">{{activityPoints.title}}</div>
                    </header>
                    <div class="shortdesc">{{activityPoints.shortdesc}}</div>
                    <div class="intro" v-if="activityPoints.description">
                        <div class="introtitle">
                            
                        </div>
                        <div >
                            <div v-html="activityPoints.description"></div>
                        </div>
                    </div>

                    <footer style="margin-top:10px;color:#393940;font-size: .3rem;"
                            v-if="activityPoints.msg && activityPoints.futurecan*1">
                        您还可以继续点亮 <span style="color: #FF5D4B">{{activityPoints.futurecan}}</span>个<br>是否继续点亮?
                    </footer>

                    <div class="button" @click="handleSteps" v-if="activityPoints.futurecan*1">继续点亮</div>

                    <div  style="color:#999;font-size: .3rem;margin-top:10px;"  @click="pointShow=false" v-if="activityPoints.futurecan*1">
                        取消
                    </div>
                    <div class="button" @click="pointShow=false" v-else>
                       确定
                    </div>

                </div>
            </div>
        </Popup>
        <Popup
            v-model="groupShow"
            :style="{ width: '80%',overflowY:'auto' }"
            round
            close-on-click-overlay
            @closed="groupShow = false"
        >
            <div class="group">
                <div class="title">我的队伍</div>
                <div class="title2">
                    <div>
                        邀请好友组队为步数加速队伍里每多一个好友，步数获取量增加2%，上限30%
                    </div>
                    <div>
                        注：同一场活动只能加入一个队伍
                    </div>
                    
                </div>
                <div class="gl">
                    <div class="gt" v-for="item in grouplist">
                        <img :src="item.avatarurl">
                        <div>{{item.nickname}}</div>
                    </div>

                    <div class="gt" @click="goshow">
                        <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20230829/1693291311/355639.jpg">
                        <div></div>
                    </div>
                </div>
            </div>
        </Popup>
        <van-overlay z-index="1000" :show="show" @click="show = false">
            <div class="wrapper">
                <img style="width:100%" src="../../../assets/img/common/share.png" />
            </div>
        </van-overlay>
        <Popup
            v-model="subshow"
            round
            close-on-click-overlay
            @closed="subshow = false"
        >
            <div class="xanswerDetail">
                <div class="xxtitle">
                </div>
                <div class="qu_list">
                    <div class="qu_t"><div>选择任一点位提交现场照片</div><div>完成点位打卡</div></div>
                    <div class="checkbox">
                        <van-radio-group v-model="subname" direction="horizontal">
                            <van-radio name="武康路旅游咨询中心（上海老房子艺术中心）">武康路旅游咨询中心（上海老房子艺术中心）</van-radio>
                            <van-radio name="徐家汇书院">徐家汇书院</van-radio>
                            <van-radio name="西岸美术馆">西岸美术馆</van-radio>
                        </van-radio-group>
                    </div>
                    
                    <div class="boxs" bindtap="uploadimage">
                        <!-- <img v-if="mediaurl == ''" src="https://oss.mcloud.moveclub.cn/alphamovecloud/20230912/1694503434/897804.png" /> -->
                        <UploadImage :item="item" :fileList="[]" @setUrl="setUrl" />
                        <!-- <text wx:if="{{mediaurl}}">{{mediaurl}}</text> -->
                        <span >点击，上传照片</span>
                    </div>
                </div>
                <div class="btn">
                    <div class="mvbutton go" @click="handleSut">提交</div>
                </div>
                
            </div>
        </Popup>
    </div>
</template>
<script>
    var points = [
      [[682,373],[687,314],[511,313]],
      [[511,313], [394,313]],
      [[394,313], [301,315], [285,440]],
      [[285,440],[264,635]],
      [[264,635],[239,848]],
      [[239,848],[227,975],[378,975]],
      [[378,975],[613,975]],
      [[613,975],[628,843]],
      [[628,843],[439,843]],
      [[439,843],[381,843],[392,723]],
      [[392,723],[411,562]],
      [[411,562],[426,439],[522,440]],
      [[522,440],[672,439],[682,373]],
      [[682,373],[687,314],[511,313]],
      [[511,313],[165,392]],
      [[131,635]],
      [[104,915]]
    ];
    for(var i = 0;i<points.length;i++){
      for(var j = 0;j<points[i].length;j++){
        for(var z = 0;z<points[i][j].length;z++) {
            if (z % 2 === 0) {
                points[i][j][z] = (points[i][j][z] - 335)*0.000004487*10 + 121.491708
            } else {
                points[i][j][z] = ((1451-points[i][j][z]) - 525)*0.000003457*10 + 31.196219
            }
        }       
      }
    }

    var offset = [
        [-15, -10], //1
        [-15, 0], //2
        [-10, 12],//3
        [-5, 12],//4
        [-5, 12],//5
        [-15, 0],//6
        [-15, 0],//7
        [-5, 0],//8
        [-5, 0],//9
        [-5, 12],//10
        [-5, 12],//11
        [-15, 0],//12
        [0, 0], //13
        [-5, 12],  //14
        [-5, 12], //15
        [-5, 12],
        [-15, 12],
        [-15, 12],
        [-15, 12],
        [-15, 12],
        [-15, 12],
        [-15, 12],
        [-15, 20],
    ];
    var offset14 = [
        [-15, 11], //1
        [-15, 20], //2
        [-15, 0],//3
        [-15, 0],//4
        [-15, 5],//5
        [-15, 20],//6
        [-15, 20],//7
        [-15, 20],//8
        [-15, 20],//9
        [-15, 0],//10
        [-15, 0],//11
        [-25, 20],//12
        [-15, 20], //13
        [-15, 20],  //14
        [-15, 20], //15
        [-15, 20],
        [-15, 12],
        [-15, 12],
        [-15, 12],
        [-15, 12],
        [-15, 12],
        [-15, 12],
        [-15, 20],
    ];
    let arr = []

    import {mapGetters} from "vuex";
    import PinchZoom from "vue-pinch-zoom";
    import {Button, Image, Loading, Swipe, SwipeItem, Popup, Collapse, CollapseItem, NoticeBar, RadioGroup, Radio,Dialog,Overlay} from "vant";
    import Footbar from "@/components/footbar/index";
    import ICountUp from "vue-countup-v2";
    import {lazyAMapApiLoaderInstance} from "vue-amap";
    import moment from 'moment';

    import UploadImage from "@/components/UploadImage/index";
    // import VConsole from 'vconsole'

    export default {
        name: "checkDetail",
        props: ["activity_id","acid"],
        computed: {
            ...mapGetters({
                userInfo: "getUserInfo"
            })
        },
        data() {
            return {
                showMore:false,
                activityPoints:{},
                collapsename: [],
                hasques: false,
                point: [],
                pointShow: false,
                pointShowFrom: 1,
                rulesShow: false,
                userTaskInfo: {
                    currentFinished: 0,
                    totalSteps: 0
                },
                sigining: false,
                freenum: 0,
                detail: {},
                markers:[],
                markers14:[],
                grouplist:[],
                systime: '',
                answershow: false,
                groupShow: false,
                show: false,
                lettersarr: [
                  "A",
                  "B",
                  "C",
                  "D",
                  "E",
                  "F",
                  "G",
                  "H",
                  "I",
                  "J",
                  "K",
                  "L",
                ],
                question: {},
                answer: [],
                bind_subid: '',
                drawshow: false,
                answererror: false,
                check: '',
                finished: 0,
                mediaurl: '',
                subshow: false,
                item: {key_name:'mediaurl'},
                slist: [],
                wlist: [],
                list: [],
                subname: '武康路旅游咨询中心（上海老房子艺术中心）'
            };
        },
        components: {
            Button,
            VanImage: Image,
            Footbar,
            Loading,
            Swipe,
            SwipeItem,
            ICountUp,
            Popup,
            PinchZoom,
            Collapse,
            CollapseItem,
            VanNoticeBar:NoticeBar,
          VanRadioGroup:RadioGroup,
          VanOverlay: Overlay,
          VanRadio:Radio,
          UploadImage
        },
        methods: {
            handleSut:function (){
                let that = this
                if(this.mediaurl == ''){
                    this.$toast('请上传照片');
                    return;
                }
                this.$toast.loading("处理中...");
                let obj = {mediaurl:this.mediaurl,subname:this.subname}
                this.$api.sports.submitStp({ cpgid:9942,mediaurl:this.mediaurl,registerinfos:JSON.stringify(obj)})
                    .then((res) => {
                        if (res.status * 1 === 200) {
                        this.$toast.clear();
                        this.subshow = false;
                        this.sigining = false;
                        this.activityDetail();
                        // this.getTaskList();
                        this.getUser()             
                        
                        }
                    })
            },
          gorank() {
            this.$router.push({name:'xhrank23',params:{activity_id:this.activity_id}})
          },
          setUrl: function (res, key) {
            // console.log(res, key)
                let arr = JSON.parse(res)
                this.mediaurl = arr[0]
            },
            getcard() {
              this.$api.activity
                  .getCert({id: this.activity_id})
                  .then(res => {
                    wx.previewImage({
                      urls: [res.data.cert]
                    });
                  });
              return;
            },
            getpic() {
                wx.miniProgram.navigateTo({url: '/pages/user/record/index'})
            },
            gofinsh() {
                this.$toast('您上传的照片已经通过审核，您已经完成附加赛。请静待后续盲盒抽奖');
            },
            handleSteps() {
                let that = this
                var timestamp = this.systime;
                var starttime = this.detail.start_time*1
                // var endtime = this.detail.end_time*1
                if(timestamp<starttime){
                  this.$toast('还未开始，请耐心等待');
                  return;
                }
                // let list = this.point
                // let  res = list.find(item => item.hasanswer == 0&&item.playerInfo != null)
                // if(res){
                //   this.getques()
                //   this.answershow = true
                //   this.bind_subid = res.id
                //   this.answer = []
                //   return
                // }
                if(this.userTaskInfo.currentFinished == 12) {
                    this.$toast('你已完成所有点位打卡');
                    return
                }
                // if(this.userTaskInfo.currentFinished >=12 && this.userTaskInfo.totalSteps>=this.detail.step*(this.userTaskInfo.currentFinished+1)) {
                //     this.subshow = true
                //     return
                // }
                this.$toast.loading("处理中...");
                this.$api.steps.groupstepsCheckin(Object.assign({api_throw_exception: false,cpgid:9942}, this.$route.params)).then(
                   res => {

                      this.sigining = false;
                      this.$toast.clear();
                      if (+res.status !== 200) {
                          this.$toast({
                              type: 'html',
                              position: "bottom",
                              message: "<div style='display: flex;align-items: center;font-size:12px;'>" +
                                  "<img src='" + require("@/assets/img/steps/run.png") + "' style='width:.44rem;height:.44rem;margin-right: 5px;'>" + res.message + "</div>",
                              duration: 5000,
                              className: "bottomToast"
                          })

                          return;
                      }

                      let {finided, betweenSteps} = res.data;
                      this.activityPoints = Object.assign(finided,{playerInfo:{}});
                      if (!this.pointShow) this.pointShow = true;
                      if (this.userTaskInfo.currentFinished == 11) { 
                        this.pointShow = false                      
                        let message = "<div style='display: flex;align-items: center;justify-content:center;width:4.5rem;height:4.5rem;'><img src='https://oss.mcloud.moveclub.cn/alphamovecloud/20230914/1694676716/908184.jpg' style='width:4rem;height:4rem;'></div>"
                        this.$toast({
                            type: 'html',
                            message: message,
                            overlay: false,
                            duration: 8000
                        })
                      }
                      this.userTaskInfo.totalSteps = betweenSteps;
                      this.activityDetail();
                    //   this.getTaskList();
                      this.getUser()
                    },
                    () => {

                    }
                );
            },
            gogroup() {
                let that = this
                if(this.userTaskInfo.groupid == '') {
                    this.$dialog.confirm({
                        title: '确认',
                        message: '同一场活动只能创建/加入一个队伍，且不能更换，是否创建？',
                    })
                    .then(() => {
                        // on confirm
                        that.$api.user.upstepsgroup({acid:that.$route.params.activity_id}).then(res=>{
                            // that.getTaskList()
                            that.getUser()
                        })
                    })
                    .catch(() => {
                        // on cancel
                    });
                } else {
                    this.$api.user.grouplist({acid:that.$route.params.activity_id,groupid:that.userTaskInfo.groupid}).then(res=>{
                        if(res.status == 200) {
                            this.grouplist = res.data
                            this.groupShow = true
                        }
                    })
                }
            },

            goshow() {
                let url = window.location.origin+'/xh/share/'+this.userTaskInfo.groupid + '/'+ this.$route.params.activity_id
                if(this.$route.params.acid) url += '/' + this.$route.params.acid
                const shareConf = {
                    title: ` 动动手指，加入我的队伍吧！`,
                    path: '/pages/webview/index?src=' + encodeURIComponent(url),
                }

                wx.miniProgram.postMessage({ data: JSON.stringify(shareConf) })
                this.show = true
                this.groupShow = false
            },

            getTaskList() {
                let that = this;
                new Promise(function (resolve, reject) {
                    //先清除所有的marker
                    that.map.remove(that.markers14)
                    that.map.remove(that.markers);
                    that.$api.activity.taskList(that.$route.params).then(res => {
                        if (res.status * 1 === 200) {
                            var {subList, intro, title, relation_actvity_id, relation_activity_type} = res.data;
                            var currentFinished = 0;
                            var playerInfo =  that.slist.length>0?{id: "684527"}:null
                            subList.unshift({
                                imgurl: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20230828/1693216490/776149.jpg',
                                icon: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20230828/1693216490/776149.jpg'
                            })
                            subList.push({
                                imgurl: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20230918/1695028763/792219.png',
                                icon: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20230918/1695028763/792219.png'
                            })
                            subList.push({
                                imgurl: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20230912/1694489795/1694489805888/组3455.png?x-oss-process=image/crop,x_0,y_0,w_120,h_120',
                                icon: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20230913/1694595964/1694595968906/图层4.png?x-oss-process=image/crop,x_0,y_0,w_120,h_120',
                                description: '<p><img class="wscnph" style="display: block; margin-left: auto; margin-right: auto;" src="https://oss.mcloud.moveclub.cn/alphajiushivip/20230912/1694489984.1694490086191" width="280" /></p>↵<p>&nbsp;</p>↵<p>武康路旅游咨询中心位于武康路393号甲，所在建筑建于1933年，是上海市文物保护单位和优秀历史建筑。作为徐汇区文旅公共服务体系的1级旗舰店，以&ldquo;i&rdquo;的信息咨询理念，为游客提供文旅公共服务的服务窗口。</p>',
                                playerInfo: playerInfo,
                                title: '武康路旅游咨询中心（上海老房子艺术中心）',
                                shortdesc: ''
                            })
                            subList.push({
                                imgurl: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20230912/1694489887/1694489897676/组3456.png?x-oss-process=image/crop,x_0,y_0,w_120,h_120',
                                icon: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20230913/1694595975/1694595983113/图层2.png?x-oss-process=image/crop,x_0,y_0,w_120,h_120',
                                description: '<p><img class="wscnph" style="display: block; margin-left: auto; margin-right: auto;" src="https://oss.mcloud.moveclub.cn/alphajiushivip/20230912/1694490109.1694490171336" width="280" /></p>↵<p>&nbsp;</p>↵<p>徐家汇书院是徐汇区图书馆新馆，徐汇区文旅新空间和文化新地标，是一座文博形象出色、文化内涵丰厚的创新型、复合型图书馆，在这里可以&ldquo;阅人、阅城、阅海派，读文、读艺、读建筑&rdquo;。</p>',
                                playerInfo: playerInfo,
                                title: '徐家汇书院',
                                shortdesc: ''
                            })
                            subList.push({
                                imgurl: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20230912/1694489920/1694489922640/组3457.png?x-oss-process=image/crop,x_0,y_0,w_120,h_120',
                                icon: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20230913/1694595991/1694595994734/图层3.png?x-oss-process=image/crop,x_0,y_0,w_120,h_120',
                                description: '<p><img class="wscnph" style="display: block; margin-left: auto; margin-right: auto;" src="https://oss.mcloud.moveclub.cn/alphajiushivip/20230912/1694490183.1694490190070" width="280" /></p>↵<p>&nbsp;</p>↵<p>西岸美术馆位于上海徐汇滨江，是&ldquo;西岸美术馆大道&rdquo;的核心公共文化场馆之一。由英国著名建筑师戴卫&middot;奇普菲尔德爵士设计，于2019年正式开放，同年与法国乔治&middot;蓬皮杜国家艺术文化中心达成中法最高级别文化合作项目。</p>',
                                playerInfo: playerInfo,
                                title: '西岸美术馆',
                                shortdesc: ''
                            })


                            var finshedLine = [];
                            var finshedfirstpoint = [];
                            var markers = [];
                            var markers14 = [];

                            // if(relation_actvity_id != ''&&relation_activity_type==5){
                            //   that.hasques = true
                            // }

                            subList.forEach((item, index) => {
                                if (!!item.playerInfo) {
                                    currentFinished++;
                                    var icon = new AMap.Icon({
                                        size: index>=13?new AMap.Size(90, 90):new AMap.Size(70, 70),    // 图标尺寸
                                        image: item.imgurl,
                                        imageSize: index>=13?new AMap.Size(90, 90):new AMap.Size(70, 70),   // 根据所设置的大小拉伸或压缩图片
                                    });
                                    var marker = new AMap.Marker({
                                        position: points[index][points[index].length - 1],
                                        icon: icon, // 添加 Icon 实例
                                        offset: new AMap.Pixel(offset[index][0], offset[index][1]), //设置偏移量
                                        anchor: 'bottom-left', // 设置锚点方位
                                        title: index,
                                        zIndex:1000
                                    });

                                    marker.on('click', function (e) {
                                        that.markerClick(e)
                                    })


                                    var icon14 = new AMap.Icon({
                                        size: index>=13?new AMap.Size(60, 60):new AMap.Size(35,35),    // 图标尺寸
                                        image: item.imgurl,
                                        imageSize: index>=13?new AMap.Size(60, 60):new AMap.Size(35,35),   // 根据所设置的大小拉伸或压缩图片
                                    });
                                    var marker14 = new AMap.Marker({
                                        position: points[index][points[index].length - 1],
                                        icon: icon14, // 添加 Icon 实例
                                        offset: new AMap.Pixel(offset14[index][0], offset14[index][1]), //设置偏移量
                                        anchor: 'bottom-left', // 设置锚点方位
                                        title: index,
                                        zIndex:1000
                                    });

                                    marker14.on('click', function (e) {
                                        that.markerClick(e)
                                    })


                                    var content = '<div class="first-pointx activity">' + (index+1) + "</div>";
                                    finshedfirstpoint.push(
                                        new AMap.Marker({
                                            position: points[index][points[index].length - 1],
                                            content,
                                            offset: new AMap.Pixel(-12.5,5), //设置偏移量
                                            anchor: 'bottom-left', // 设置锚点方位
                                            zooms: [14,16],
                                            zoom: 15,
                                        })
                                    );
                                    finshedLine = finshedLine.concat(points[index])
                                    console.log(finshedLine,'finshedLine')
                                    if(currentFinished==12){
                                        finshedLine = finshedLine.concat(arr[33],arr[34],arr[35])
                                    }
                                } else {
                                    var icon = new AMap.Icon({
                                        size: index>=13?new AMap.Size(90, 90):new AMap.Size(70, 70),    // 图标尺寸
                                        image: item.icon,
                                        imageSize: index>=13?new AMap.Size(90, 90):new AMap.Size(70, 70),   // 根据所设置的大小拉伸或压缩图片
                                    });

                                    var marker = new AMap.Marker({
                                        position: points[index][points[index].length - 1],
                                        icon: icon, // 添加 Icon 实例
                                        offset: new AMap.Pixel(offset[index][0], offset[index][1]), //设置偏移量
                                        anchor: 'center', // 设置锚点方位
                                        title: index,
                                        zooms: [14,16],
                                        zoom: 15,
                                        zIndex:999

                                    });

                                    AMap.event.addListener(marker,'click',that.markerClick);

                                    marker.on('click', function (e) {
                                        that.markerClick(e)
                                    })



                                    var icon14 = new AMap.Icon({
                                        size: index>=13?new AMap.Size(60, 60):new AMap.Size(35, 35),    // 图标尺寸
                                        image: item.icon,
                                        imageSize: index>=13?new AMap.Size(60, 60):new AMap.Size(35, 35 ),   // 根据所设置的大小拉伸或压缩图片
                                    });
                                    var marker14 = new AMap.Marker({
                                        position: points[index][points[index].length - 1],
                                        icon: icon14, // 添加 Icon 实例
                                        offset: new AMap.Pixel(offset14[index][0], offset14[index][1]), //设置偏移量
                                        anchor: 'bottom-left', // 设置锚点方位
                                        title: index,
                                        zIndex:1000
                                    });

                                    marker14.on('click', function (e) {
                                        that.markerClick(e)
                                    })
                                }
                                markers.push(marker);
                                markers14.push(marker14);
                            });
                            // 已经完成的创建折线实例
                            // console.log(finshedLine,'finshedLine')
                            if(finshedLine.length>=33) finshedLine.splice(33)
                            if(finshedLine.length>0){
                                var polyline = new AMap.BezierCurve({
                                    path: finshedLine,
                                    lineJoin: "round",
                                    lineCap: "round",
                                    strokeWeight: 1,
                                    strokeColor: "#FFFFFF",
                                    outlineColor: "#C74E65",
                                    borderWeight: 5,
                                    isOutline: true,
                                    strokeStyle: "dashed"
                                });
                                polyline.setMap(that.map)
                            }

                            that.markers = markers;
                            that.markers14 = markers14;

                            var zoom = that.map.getZoom()
                            if(zoom==14){
                                that.map.add(markers14)
                            }else{
                                that.map.add(markers);
                            }
                            that.map.add(finshedfirstpoint);
                            that.point = res.data.subList;
                            that.detail = res.data;
                            that.systime = res.timestamp
                            that.userTaskInfo.currentFinished = currentFinished;
                            that.userTaskInfo.join_start_time = moment(res.data.start_time*1000).format('MM月DD日');
                            // let index = currentFinished - 1 <= 0 ? 0 : currentFinished - 1
                            // index = index + 1 >= 12 ? 12 : (index + 1)
                            that.map.setCenter(//不变
                                points[0][0]
                            );
                            resolve(Object.assign(res.data, {currentFinished}));
                        }
                    });
                }).then(e => {
                    let {start_time, end_time} = e;
                    that.$api.steps.stepsInfo({start_time, end_time}).then(res => {
                        
                    }).then(res=>{
                        that.$api.user.upsteps({acid:that.$route.params.activity_id}).then(res=>{
                            if (+res.status === 200) {
                                that.userTaskInfo = Object.assign(that.userTaskInfo, {
                                    totalSteps: res.data.steps*1,count:res.data.count,groupid:res.data.groupid,percent: res.data.percent*100
                                });
                            }
                        })
                    });
                });
            },
            activityDetail: function () {
                if(!this.acid) return
                this.$api.activity.activityDetail({acid: this.acid}).then(res => {
                    this.freenum = res.data.freenum;
                });           
            },
            getUser: function () {
                this.$api.sports.myList({sports_id: 9994,sports_item_id:390,sports_item_sub_id:9942}).then(res => {
                    this.slist = []               
                    this.wlist = []               
                    this.list = res.data.list               
                    let arr = res.data.list.find(item=>item.state*1===1)
                    if(arr) this.slist.push(arr)
                    let arr2 = res.data.list.find(item=>item.state*1===0)
                    if(arr2) this.wlist.push(arr2)
                    this.getTaskList();
                });           
            },
            goluckdraw: function () {
                if(!this.acid) return
                this.$router.push({name: "luckdraw", params: {acid: this.acid}});
            },
            markerClick: function (e) {
              console.log(e.target.getTitle(),111)
                if(+e.target.getTitle()===0 && +e.target.getTitle()===22) return
                // if(+e.target.getTitle()===22 && this.userTaskInfo.currentFinished<22){

                //     this.$dialog.alert({
                //         title: '提示',
                //         width:'80vw',
                //         message: '您还未走完本次活动的其他点位。\r\n完成所有任务后可查看该点位详情！',
                //     }).then(() => {
                //         // on close
                //     });
                //     return ;
                // }


                this.activityPoints = this.point[e.target.getTitle()];
                this.pointShow = true;
                this.pointShowFrom = 2;
            },
            closepointShow: function () {
                this.pointShowFrom = 1;
                this.collapsename = []
                this.activityPoints= {}
                this.pointShow = false;
            }
        },
        mounted() {        
            this.$api.user.getUserInfo().then((res) => {
            if (res.status * 1 === 200) {
                let userInfo = res.data;
                if(userInfo.nickname == '微信用户' ||userInfo.phone == '' ||userInfo.phone == null){
                    Dialog.alert({
                        title: '温馨提醒',
                        message: '为便于后续奖励登记发放，请到个人中心完善昵称、姓名、手机号等个人信息',
                    })
                    .then(() => {
                        // on confirm
                        wx.miniProgram.reLaunch({
                            url:'/pages/user/bindphone/index'
                        });
                    });
                }
            }
            });
            
        //   new VConsole()
            // this.$nextTick(() => {
            lazyAMapApiLoaderInstance.load().then(() => {
                var imageLayer = new AMap.ImageLayer({
                    url: "https://oss.mcloud.moveclub.cn/alphamovecloud/20230913/1694604149/306659.jpg",
                    bounds : new AMap.Bounds(
                        [121.461777,31.163559], [121.524253,31.227726]
                    ),
                    zooms: [14,16],
                    zoom: 15,
                    opacity:.5
                });
                let layer_std = new AMap.TileLayer();
                this.map = new AMap.Map("amapContainer", {
                    resizeEnable: true,
                    center: [121.491708,31.196219],
                    zooms: [14,16],
                    zoom: 14,
                    layers: [layer_std, imageLayer],
                    mapStyle: "amap://styles/whitesmoke",
                });

                this.map.remove(layer_std);
                var linePoint = [];
                var firstPointMarkers = [];
                points.forEach((item, index) => {
                    linePoint = linePoint.concat(item);
                    var content = '<div class="first-pointx">' + index + "</div>";
                    if (index) {
                        firstPointMarkers.push(
                            new AMap.Marker({
                                position: item[0],
                                content,
                                animation:"AMAP_ANIMATION_DROP",
                                offset: new AMap.Pixel(-12.5,5), //设置偏移量
                                anchor: 'bottom-left', // 设置锚点方位
                            })
                        );
                    }

                });
             //限制范围
                var bounds = new AMap.Bounds(
                    [121.47724767,31.17703081], [121.51090017,31.22314719]
                )
                this.map.setLimitBounds(bounds);
                this.map.add(firstPointMarkers);
                var that = this;
                linePoint.splice(36)
                arr = linePoint
                console.log(linePoint,'linePoint')
                setTimeout(() => {
                    var polyline = new AMap.BezierCurve({
                        path: linePoint,
                        lineJoin: "round",
                        lineCap: "round",
                        strokeWeight: 1,
                        strokeColor: "#FFFFFF",
                        outlineColor: "#999999",
                        borderWeight: 5,
                        isOutline: true,
                        strokeStyle: "dashed"
                    });
                    polyline.setMap(that.map)
                    that.activityDetail();
                    that.getUser()
                }, 1)

                this.map.setFeatures("building")

                this.map.on("click",function (e) {
                    console.log(e);
                })

                this.map.on('zoomend',function (e) {
                    var zoom = that.map.getZoom()
                    if(zoom==14){
                        that.map.remove(that.markers);
                        that.map.add(that.markers14)
                    }else{
                        that.map.remove(that.markers14)
                        that.map.add(that.markers);
                    }

                })



            });

            // })

        }
    };
</script>
<style lang="less">
    @import "Detail.less";
</style>
